var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ((_obj = {}), (_obj[_vm.$style.cont] = !_vm.compact), _obj),
      staticStyle: { "text-align": "center" }
    },
    [
      _c(
        "div",
        {
          class:
            ((_obj$1 = {}),
            (_obj$1[_vm.$style.loaderCont] = !_vm.compact),
            _obj$1)
        },
        [
          _c("div", {
            staticClass: "ui centered inline loader active workaround",
            class: [_vm.size]
          })
        ]
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }